import { ActionTypes } from "../constants/action-types";

const initialState = {
  loading: false,
  success: false,
  error: null,
};

export const passwordResetReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.RESET_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null };
    case ActionTypes.RESET_PASSWORD_SUCCESS:
      return { ...state, loading: false, success: true };
    case ActionTypes.RESET_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
     return state;
  }
};


 export default passwordResetReducer;
